module.exports = __webpack_public_path__ + "static/img/share_medical_record.a952793.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share_medical_record.jpg
// module id = 8Gwp
// module chunks = 7